module.exports = __webpack_public_path__ + "media/images/tag-c4d93eb09340e268255201f87edae046.svg";